import { getState, ModelState } from '@modelsjs/model';
function isUndefined(value) {
    return typeof value === 'undefined';
}
export function isResolvable(model) {
    return getState(model) === ModelState.Initial;
}
export function isResolved(model) {
    return !isResolvable(model);
}
export function split(array, match) {
    return array.reduce((acc, item) => {
        acc[match(item) ? 0 : 1].push(item);
        return acc;
    }, [[], []]);
}
export function has(key) {
    return (item) => key in item;
}
export const transaction = (fields, onchange) => function transaction(tx) {
    const state = fields.reduce((acc, key) => {
        acc[key] = this[key];
        return acc;
    }, {});
    tx();
    const changed = fields.filter((field) => {
        return this[field] !== state[field];
    });
    if (changed.length) {
        onchange(changed.map((field) => [field, state[field], this[field]]));
    }
};
const call = (...args) => (fn) => fn(...args);
export const events = (fields) => {
    const subscriptions = fields.reduce((acc, field) => {
        acc[field] = new Set();
        return acc;
    }, {});
    return {
        subscribe(field, handler) {
            subscriptions[field].add(handler);
            return () => {
                subscriptions[field].delete(handler);
            };
        },
        notify(field, prev, next) {
            if (subscriptions[field].size) {
                [...subscriptions[field]].forEach(call(next, prev));
            }
        }
    };
};
